import { iconCss } from "./index.styles";

import { KibelaSymbol } from "~/client/components/shared/kibela_symbol";

/* eslint-disable @typescript-eslint/naming-convention */
const iconIds = {
  "Note": "file",
  "Comment": "comment",
  "CommentReply": "comment",
};
/* eslint-enable @typescript-eslint/naming-convention */

interface Props {
  typename: keyof typeof iconIds;
  size?: string;
}
export const EntryIcon: React.FC<Props> = ({ typename, size }) => {
  return <KibelaSymbol id={iconIds[typename]} css={iconCss(size || "1.6rem")} />;
};
